import { RestClient } from '@libs/rest-client';
import type { AdminUserState, SsoStatus, UserState } from '../../../types';
import type { AdminLoginCredentials, LoginCredentials } from '../models';

const LOGIN_URL = '/login';
const ADMIN_LOGIN_URL = `/root${LOGIN_URL}`;
const SANDBOX_LOGIN_URL = `/sandbox${LOGIN_URL}`;
const ROOT_MFA_CHALLENGE_URL = '/root/mfa-challenge';

async function signIn(credentials: LoginCredentials, isSandbox: boolean | undefined) {
  return await RestClient.auth.post<UserState>(isSandbox ? SANDBOX_LOGIN_URL : LOGIN_URL, credentials);
}

async function adminSignIn(credentials: AdminLoginCredentials) {
  return await RestClient.auth.post<AdminUserState>(ADMIN_LOGIN_URL, credentials);
}

async function checkSandboxExistence(organizationName: string) {
  return await RestClient.fa.get('/sandbox/find-resource', { organizationName });
}

async function fetchUserPoolInfo(organizationId: string) {
  return await RestClient.auth.get<{
    cognitoDomain: string;
    clientId: string;
    idpName: string;
  }>(`/sso/user-pool-info?organizationId=${organizationId}`);
}

async function fetchTokensBy(organizationId: string, code: string, redirectUri: string) {
  return await RestClient.auth.post<{ region: string }>('/sso/token', { organizationId, code, redirectUri });
}

async function fetchSsoStatus(organizationId: string) {
  const res = await RestClient.auth.post<{
    organizationName: string;
    ssoStatus: SsoStatus;
  }>('/sso-setting/status/search', { organizationId });
  return {
    ...res,
    organizationId,
  };
}

async function mfaChallenge(email: string, session: string, verificationCode: string) {
  return await RestClient.auth.post(ROOT_MFA_CHALLENGE_URL, { email, session, verificationCode });
}

export {
  adminSignIn,
  checkSandboxExistence,
  fetchSsoStatus,
  fetchTokensBy,
  fetchUserPoolInfo,
  mfaChallenge,
  signIn,
};
